<template>
  <div class="base">
    <dropzone
        :id="id"
        ref="dropzone"
        :options="options"
        @vdropzone-file-added="onFileAdded"
        @vdropzone-removed-file="onRemovedFile" />
  </div>
</template>

<style scoped>
.base >>> .dz-preview.dz-image-preview > .dz-image {
  position: relative;
}
.base >>> .dz-preview.dz-image-preview > .dz-image > img[data-dz-thumbnail] {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
</style>

<script>
import _ from 'lodash'
import path from 'path'
import uuid from 'uuid/v4'
import Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import * as config from '@/config'

const DROPZONE_ID = uuid()

export default {
  name: 'DropImage',
  components: {
    Dropzone
  },
  props: {
    productCode: {
      type: String,
      default: ''
    },
    colorCode: {
      type: String,
      default: ''
    },
    imageList: {
      type: Array,
      default: () => []
    },
    images: {
      type: Array,
      default: () => []
    },
    fileDataList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    id () {
      return DROPZONE_ID
    },
    options () {
      return {
        autoProcessQueue: false,
        url: new URL('image', config.PRODUCT_API_URL).href,
        maxFileSize: 20,
        maxFiles: 200,
        parallelUploads: 4,
        acceptedFiles: '.jpg,.jpeg,.png,.bmp,.gif',
        previewTemplate: `
          <div class="dz-preview dz-file-preview">
              <div class="dz-image" style="width: 200px;height: 200px">
                  <img data-dz-thumbnail />
              </div>
              <div class="dz-details">
              </div>

              <div class="dz-error-message"><span data-dz-errormessage></span></div>
              <div class="dz-success-mark">
                Success!<i class="fa fa-check"></i>
              </div>
              <div class="dz-error-mark"><i class="fa fa-close"></i></div>
          </div>
        `,
        addRemoveLinks: true
      }
    }
  },
  mounted () {
    this.loadImage()
  },
  updated () {
    this.loadImage()
  },
  methods: {
    getImageUrl: function (image) {
      const fileName = _.get(image, 'fileName')
      if (fileName) {
        return new URL(path.join('image/thumb', fileName) + '?width=200', config.PRODUCT_API_URL).href
      }
      const dataURL = _.get(image, 'file.dataURL')
      if (dataURL) {
        return dataURL
      }
    },
    onFileAdded (file) {
      if (!file.manuallyAdded) {
        const id = uuid()
        this.imageList.push({ id, isNew: true,
          displayOrder: _.max(this.imageList.map((image) => image.displayOrder)) + 1 })
        file.id = id

        this.fileDataList.push({ id, file })
      }
    },
    onRemovedFile (file, error, xhr) {
      const index = _.findIndex(this.imageList, (val) => file.id === val.id)
      if ((this.imageList[index] || {}).isNew === true) {
        this.fileDataList.splice(this.fileDataList.findIndex((img) => img.id === this.imageList[index].id), 1)
        this.$delete(this.imageList, index)
      } else if (this.imageList[index]) {
        this.imageList[index].isActive = 0
      }
    },
    async loadImage () {
      let dropzone = this.$refs.dropzone
      dropzone.dropzone.files.filter((file) => {
        return !this.images.some((image) => file.id === image.image.id)
      }).forEach((file, index) => {
        dropzone.removeFile(file)
      })

      const newImage = this.images.filter((image) => {
        return !dropzone.dropzone.files.some((file) => file.id === image.image.id)
      })

      // 非同期処理のため、ダイアログをすばやく切り替えたときに2回読み込むことがあるため、同一画像は削除
      dropzone.dropzone.files.filter((file, index) => {
        return dropzone.dropzone.files.some((otherFile, otherIndex) =>
          file.id === otherFile.id && index > otherIndex)
      }).forEach((file, index) => {
        dropzone.removeFile(file)
      })

      await Promise.all(newImage.map(async (image) => {
        if (image.image.isNew !== true) {
          const file = { size: 0, id: image.imageLoaded.id }
          await image.loadImage(true)
          dropzone.manuallyAddFile(file, image.imageLoaded.imageSignedUrl)
        }
      }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/product/DropImage.vue